function _xArrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);

    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }

    idx += 1;
  }

  return xf['@@transducer/result'](acc);
}

module.exports = _xArrayReduce;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reduxsauce/node_modules/ramda/src/internal/_xArrayReduce.js
// module id = 650
// module chunks = 57